module.exports = __webpack_public_path__ + "img/L_322_0.a13c8cac.png";